<ng-container *ngIf="loaderService.sidebarSubject$ | async">
  <button (click)="goBack()" type="button" class="back-button">
    <img src="/assets/images/arrow-left.svg" style="width: 38px;" />
    <span>Back</span>
  </button>
</ng-container>